export interface Environment {
  development: boolean;
  apiUrl: string;
  imagesUrl: string;
  useMocks: boolean;
  secretKeyBase: string;
  changingHealthToken: string;
  unitId: number;
  packageId: number;
  knowdiabetesUnitId: number;
  knowdiabetesPackageId: number;
  chUrl: string;
}

interface Environments {
  dev: Environment;
  staging: Environment;
  prod: Environment;
  secretKeyBase?: string;
  changingHealthToken?: string;
  unitId?: number;
  packageId?: number;
  knowdiabetesUnitId?: number;
  knowdiabetesPackageId?: number;
}

const environment: Environments = {
  dev: {
    development: true,
    apiUrl: 'https://api.changinghealth.com/api/ext/user',
    useMocks: false,
    secretKeyBase: '',
    changingHealthToken: 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwOi8vbG9jYWxob3N0IiwiaWF0IjoxNjQwMDkwMTY1LCJleHAiOjE5NTU0NTAxNjUsIm5iZiI6MTY0MDA5MDE2NSwianRpIjoiUk9SYkVCc1VnMWo3TXRvSSIsImFwcF9pZCI6IjIwIiwiaXAiOltdfQ.ERqCXZW9iv_auOaXnGQnJPoKS_WM-rWBctgS0YJve5k',
    unitId: 29,
    packageId: 75,
    knowdiabetesUnitId: 29,
    knowdiabetesPackageId: 75,
    chUrl: 'https://app.dev.changinghealth.com',
  } as Environment,
  staging: {
    development: false,
    apiUrl: 'https://api.changinghealth.com/api/ext/user',
    useMocks: false,
    secretKeyBase: '',
    changingHealthToken: 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwOi8vbG9jYWxob3N0IiwiaWF0IjoxNjQwMDkwMTY1LCJleHAiOjE5NTU0NTAxNjUsIm5iZiI6MTY0MDA5MDE2NSwianRpIjoiUk9SYkVCc1VnMWo3TXRvSSIsImFwcF9pZCI6IjIwIiwiaXAiOltdfQ.ERqCXZW9iv_auOaXnGQnJPoKS_WM-rWBctgS0YJve5k',
    unitId: 29,
    packageId: 75,
    knowdiabetesUnitId: 29,
    knowdiabetesPackageId: 75,
    chUrl: 'https://app.stg.changinghealth.com',
  } as Environment,
  prod: {
    development: false,
    apiUrl: 'https://api.changinghealth.com/api/ext/user',
    useMocks: false,
    secretKeyBase: '',
    changingHealthToken: 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwOi8vbG9jYWxob3N0IiwiaWF0IjoxNjQwMDkwMTY1LCJleHAiOjE5NTU0NTAxNjUsIm5iZiI6MTY0MDA5MDE2NSwianRpIjoiUk9SYkVCc1VnMWo3TXRvSSIsImFwcF9pZCI6IjIwIiwiaXAiOltdfQ.ERqCXZW9iv_auOaXnGQnJPoKS_WM-rWBctgS0YJve5k',
    unitId: 29,
    packageId: 75,
    knowdiabetesUnitId: 29,
    knowdiabetesPackageId: 75,
    chUrl: 'https://app.changinghealth.com',
  } as Environment,
};

export default environment;
